import React from "react";
import {
    Modal,
    Button,
    ConfigProvider
} from 'antd'
import { useNavigate } from "react-router-dom";
import { clearStorage } from "../utils";
import { useDispatch, useSelector } from 'react-redux'
import { setInvalidToken } from '../redux/features/main/invalidTokenSlice'

// color config
import { textTitleHome, checkCircleIcon } from '../config/constant/color/index'

const ModalInvalidToken = ({ invalidTokenPopup, setInvalidTokenPopup }) => {
  const remoteProperty = useSelector((state) => state.remote.remoteProperty);
    const dispatch = useDispatch()
    var navigate = useNavigate();
    const urlLogin = import.meta.env.VITE_AUTH0_LOGIN_URL;

    const onClickBtnPopup = () => {
        setInvalidTokenPopup(false)
        dispatch(setInvalidToken(0))
        clearStorage();
        if(remoteProperty.isUsedSSO){
            window.location.href = urlLogin;
        } else {
            navigate(`${import.meta.env.BASE_URL}login`);
        }
    }
    return (
        <ConfigProvider
            theme={{
                components: {
                    Modal: {
                        borderRadiusLG: '24px'
                    }
                },
                token: {
                    fontFamily: 'Roboto'
                }
            }}
        >
            <Modal
                open={invalidTokenPopup}
                maskClosable="false"
                closeIcon={false}
                width={420}
                centered
                footer={null}>
                <div style={{ textAlign: 'center', padding: '32px' }}>
                    <div style={{ fontSize: '22px', color: textTitleHome, marginBottom: 16, fontWeight: '500' }}>
                        Oops
                    </div>
                    <p style={{ color: textTitleHome }}>
                        Invalid or Expired Token
                    </p>
                    <Button
                        className="btn btn-sm btn-primary btn-block"
                        style={{ borderRadius: '6px', border: 'none', fontWeight: '500', marginTop: '30px', height: '48px' }}
                        name="btn-ok-invalid"
                        onClick={() => onClickBtnPopup()}>
                        OK
                    </Button>
                </div>
            </Modal>
        </ConfigProvider>
    )
}

export default ModalInvalidToken